import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ServiceRequestService } from '@shared/services/service-request.service';

@Component({
    selector: 'app-cbm-selector',
    templateUrl: './cbm-selector.component.html',
    styleUrls: ['./cbm-selector.component.scss'],
    standalone: false
})
export class CbmSelectorComponent implements OnInit {
  @Input() city: string = '';
  @Input() rating: number[] = [];
  @Input() pcabCategory: string[] = [];
  @Input() serviceType: string = 'Solar Installation';
  @Input() contractor_class: string = '';
  @Input() selectedCBMS: string[];
  @Output() onItemSelected: EventEmitter<string[]> = new EventEmitter();

  ratingIndex: number[] = []; // holds indexes of selected rating
  pcabCategoryIndex: number[] = []; // holds indexes of selected category
  searchQuery: string = '';

  contractorList: any = [];
  cbmList: any = [];
  cbmDetails: any = [];
  cbmRecommendedID: string[] = [];
  firstChoice: string = '';
  secondChoice: string = '';
  cbmViewId: string = ''; // holds cbm id to be viewed on dialog
  cbmViewData: any = null; // holds cbm data to be viewed on dialog
  showPagination: boolean = false;
  showMore: boolean = true;
  page: number = 1;
  pageCount: number = 10;
  pageOffset: number = 0;
  resultCount: number = 0;
  showProgress: boolean = true;
  // MODALS
  showDetailModal: boolean = false;
  modal_info: boolean = false;
  info_title: string = '';
  info_message: string = '';
  uuidHolder: string[] = []

  constructor(private serviceRequest: ServiceRequestService) {}
  ngOnInit() {
    this.fetchRecommended(false);
    if (this.selectedCBMS != null) {
      this.firstChoice = this.selectedCBMS[0];
      this.secondChoice = this.selectedCBMS[1];
    }
  }
  fetchCbm() {
    if(this.searchQuery.trim() !== '') {
      this.page = 1
    }

    const body = {
      serviceType: this.serviceType,
      city: this.city,
      filters: {
        rating: this.rating,
        pcabCategory: this.pcabCategory,
      },
      page: this.page + '',
      keyword: this.searchQuery.trim(),
      contractor_class: this.contractor_class,
      //result_per_page: '5',
    };

    this.serviceRequest.getContractorList(body).subscribe(
      data => {
        this.showProgressAnim(false);
        const res = data['body'];
        // console.log('return of cbm list', data['body']);
        if(!res['results']) {
          return this.showPaginate(false); 
        }

        this.resultCount = res['results'];
        const list = res['contractors'];
        console.log('return of cbm list', list);

        this.contractorList = list;
        console.log('contractor list', this.contractorList);
        //rodel: call details

        for (const cbmItem of this.contractorList) {
          const cbmId = cbmItem.uuid;

          this.addCbm(cbmItem);
          this.updatePagination();
        }
        console.log(
          'this is the result of looping and getting the details',
          this.cbmDetails
        );
      },
      error => {
        this.showProgressAnim(false);
        console.log(error);
      }
    );

    this.showProgressAnim(true);
  }
  fetchRecommended(fetchOthers: boolean) {
    this.showProgressAnim(true);
    const body = {
      city: this.city,
      serviceType: this.serviceType,
      contractor_class: this.contractor_class,
    };

    this.serviceRequest.getRecommendedCBMS(body).subscribe(
      data => {
        if (data['status'] !== 200) {
          return;
        }
        this.showProgressAnim(false);
        const res = data['body'];
        this.cbmRecommendedID = [];
        for (const cbm of res) {
          this.cbmRecommendedID.push(cbm['uuid']);
          this.addCbm(cbm);
        }
        if (fetchOthers || res.length === 0) {
          this.fetchCbm();
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  onCbmSelected(uuid: string) {
    const index = this.uuidHolder.indexOf(uuid)
    // Max of 2 contractor will be selected
    if (index === -1 && this.uuidHolder.length === 2) {
      this.modal_info = true;
      return;
    }
    if (index !== -1) {
          this.uuidHolder.splice(index, 1)
    } else if (this.uuidHolder.length < 2) {
          this.uuidHolder.push(uuid)
    }
        this.firstChoice = this.uuidHolder[0] || ''
        this.secondChoice = this.uuidHolder[1] || ''
        this.itemSelected()
   
  //   if (uuid === this.firstChoice) {
  //     this.firstChoice = '';
  //     this.itemSelected();
  //     return;
  //   }
  //   if (uuid === this.secondChoice) {
  //     this.secondChoice = '';
  //     this.itemSelected();
  //     return;
  //   }
  //   if (this.firstChoice === '') {
  //     this.firstChoice = uuid;
  //     this.itemSelected();
  //     return;
  //   } else if (this.secondChoice === '') {
  //     this.secondChoice = uuid;
  //     this.itemSelected();
  //     return;
  //   } else {
  //     this.modal_info = true;
  //   }
   }

  itemSelected(): void {
    this.onItemSelected.emit([this.firstChoice, this.secondChoice]);
  }
  isSelected(uuid: string): boolean {
    return this.firstChoice === uuid || this.secondChoice === uuid;
  }
  getSelectionOrder(uuid: string) {
   return this.uuidHolder.indexOf(uuid)
  //  if (uuid === this.firstChoice) {
  //   return 0;
  // } else if (uuid === this.secondChoice) {
  //   return 1;
  // } else {
  //   return -1;
  // }
  }
  onPcabChanged(data: any) {
    this.pcabCategory = data;
  }
  onRatingChanged(data: any) {
    this.rating = data;
  }
  clearFilters() {
    this.clearRating();
    this.clearPcab();
    this.searchQuery = '';
    this.applyFilter();
  }
  clearRating() {
    this.rating = [];
    this.ratingIndex = [];
  }
  clearPcab() {
    this.pcabCategory = [];
    this.pcabCategoryIndex = [];
  }
  applyFilter() {
    this.cbmList = [];
    this.clearSelection();
    this.fetchCbm();
  }
  round(value: number) {
    return Math.round(value);
  }
  floor(value: number): number {
    return Math.floor(value);
  }
  onShowMore() {
    this.showMore = false;
    this.fetchCbm();
  }
  clearSelection() {
    this.firstChoice = '';
    this.secondChoice = '';
    this.itemSelected();
  }
  onCbmViewSelected(uuid: string) {
    if (!this.isSelected(uuid)) {
      this.onCbmSelected(uuid);
    }
  }

  listContains(uuid: string): boolean {
    for (const cbm of this.cbmList) {
      if (cbm['uuid'] === uuid) {
        return true;
      }
    }
    return false;
  }
  isRecommended(uuid: string): boolean {
    for (const id of this.cbmRecommendedID) {
      if (id === uuid) {
        return true;
      }
    }
    return false;
  }
  addCbm(cbm: any): void {
    if (this.listContains(cbm['uuid'])) {
      return;
    }
    if (this.isRecommended(cbm['uuid'])) {
      cbm = { ...cbm, recommended: true };
    }
    this.cbmList.push(cbm);
  }
  updatePagination() {
    this.showPagination = this.resultCount > 0;
    this.showMore = false;
    this.pageCount = Math.ceil(this.resultCount / 10);
  }
  showPage(page: number) {
    if (page === this.page) {
      return;
    }
    this.page = page;
    this.cbmList = [];
    if (page === 1) {
      this.fetchRecommended(true);
    } else {
      this.fetchCbm();
    }
  }
  showProgressAnim(visible: boolean) {
    this.showProgress = visible;
  }
  showPaginate(visible: boolean) {
    this.showPagination = visible;
  }
  // CBM DETAIL DIALOG
  viewCbmPage(uuid: string) {
    window.open('/service-request/cbm-details-view?id=' + uuid, '_blank');
  }
  viewDetail(uuid: string) {
    const cbmID = uuid;
    this.cbmViewId = cbmID;

    this.serviceRequest.getContractorDetails(cbmID, this.city).subscribe(
      data => {
        this.cbmViewData = data['body'];

        this.sortCities(this.cbmViewData);
        this.popSelectedCity(this.cbmViewData);
        this.showDetailModal = true;
      },
      error => {
        console.log(error);
      }
    );
  }

  getMaxDate() {
    let str = '';
    const date = new Date();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    str += date.getFullYear() - 18;
    str += '-';
    str += month < 10 ? '0' + month : month;
    str += '-';
    str += day < 10 ? '0' + day : day;
    return str;
  }
  sortCities(cbmData: any) {
    const list = cbmData['city'];
    let minIndex = 0;
    let minString = '';
    let temp;
    for (let c = 0; c < list.length; c++) {
      minIndex = c;
      minString = list[c]['value'];
      for (let d = c; d < list.length; d++) {
        if (list[d]['value'].localeCompare(minString) < 0) {
          minString = list[d]['value'];
          minIndex = d;
        }
      }
      temp = list[c];
      list[c] = list[minIndex];
      list[minIndex] = temp;
    }
  }
  popSelectedCity(cbmData: any) {
    if (this.city === '') {
      return;
    }
    const list = cbmData['city'];
    let index = -1;
    for (let c = 0; c < list.length; c++) {
      if (
        list[c]['value'].localeCompare(this.city, 'en', {
          sensitivity: 'base',
        }) === 0
      ) {
        index = c;
        break;
      }
    }
    if (index > -1) {
      const temp = list[0];
      list[0] = list[index];
      list[index] = temp;
    }
  }
}
